export default {"src":"/_next/static/media/target.ad461e8a.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};